export function createPageUrl(pageName) {
  // Retorna el nom de pàgina directament (les rutes usen PascalCase)
  return '/' + pageName;
}

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Converts relative /api/files/... URLs to absolute URLs using the backend base.
 * External URLs (https://) are returned as-is.
 */
export function resolveFileUrl(url) {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/api/')) return `${API_BASE}${url}`;
  return url;
}

export function formatDate(date, options = {}) {
  return new Date(date).toLocaleDateString('ca-ES', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    ...options
  });
}

export function formatTime(date) {
  return new Date(date).toLocaleTimeString('ca-ES', {
    hour: '2-digit',
    minute: '2-digit'
  });
}
